module.exports = __webpack_public_path__ + "img/yaprefer.ea8bbb84.jpg";